import { animate } from 'animejs';
import globalVar from '../utils/globalVar'

class FAQ {
  constructor() {
    let cache = {};
    
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.faqItems = document.querySelectorAll('.faq-item');
    };

    let registerEvents = () => {
      if (!cache.faqItems.length) return;

      for (let i = 0; i < cache.faqItems.length; i++) {
        const question = cache.faqItems[i].querySelector('.faq-question');
        if (question) {
          question.addEventListener('click', toggleFAQ);
        }

        const answer = cache.faqItems[i].querySelector('.faq-answer');
        if (answer) {
          if (cache.faqItems[i].classList.contains('active')) {
            const content = answer.querySelector('.faq-content');
            if (content) {
              content.style.display = 'block';
              answer.style.height = content.offsetHeight + 'px';
            }
          } else {
            answer.style.height = '0px';
          }
        }
      }
    };

    let toggleFAQ = function () {
      const item = this.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const content = answer.querySelector('.faq-content');
      const isActive = item.classList.contains('active');

      for (let i = 0; i < cache.faqItems.length; i++) {
        if (cache.faqItems[i] !== item && cache.faqItems[i].classList.contains('active')) {
          const otherAnswer = cache.faqItems[i].querySelector('.faq-answer');
          cache.faqItems[i].classList.remove('active');

          animate(otherAnswer, {
            duration: 300,
            height: 0,
            ease: 'inOutCubic',
          });
        }
      }

      if (isActive) {
        item.classList.remove('active');

        animate(answer, {
          duration: 300,
          height: 0,
          ease: 'inOutCubic'
        });
      } else {
        item.classList.add('active');
        content.style.display = "block";
        const height = content.offsetHeight;

        animate(answer, {
          duration: 300,
          height: height,
          ease: 'inQuad',
          complete: function () {
            if (item.getBoundingClientRect().top < 0) {
              document.querySelector('body').classList.add('scroll');
              animate(globalVar.scrollElement, {
                scrollTop: (globalVar.scrollElement.scrollTop + item.getBoundingClientRect().top - 100),
                duration: 300,
                ease: 'outQuad',
                complete: function () {
                  document.querySelector('body').classList.remove('scroll');
                }
              });
            }
          }
        });
      }
    };

    initFunc();
  }
}

export { FAQ };